import { useSelector } from 'react-redux';
import { FiltroReportesPermisos } from '../../../Components/Cards';
import { Encabezado } from '../../../Components/Encabezado/Encabezado';
import Loading from '../../../Components/Modals/Loading/Loader';

import { selectIsLoading } from '../../../redux/Reportes/ReportePermisosSlice';

export const Permisos = () => {
  // ? HOOK-SELECTOR
  const isLoading = useSelector(selectIsLoading);

  return (
    <Encabezado title="REPORTE DE PERMISOS">
      <div className="row">
        <div className="col">
          <FiltroReportesPermisos />
        </div>
      </div>

      {/* PANTALLA DE CARGA */}
      <Loading open={isLoading} />
    </Encabezado>
  );
};
